module.exports = __webpack_public_path__ + "img/notecase2.5afafed2.png";